import { postMobileAuthMessage } from "../mobileAuthBridge";

export function handleChannelBack({ isMobileAuth, onWebBack }) {
  if (isMobileAuth) {
    postMobileAuthMessage("FLOW_CANCELLED");
    return;
  }

  onWebBack();
}
